import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit'
import themeReducer from 'reducers/themeReducer'
import authReducer from '../reducers/authReducer'
import bookingsReducer from '../reducers/bookingsReducer'
import clientsReducer from '../reducers/clientsReducer'
import companiesHouseReducer from '../reducers/companiesHouseReducer'
import suppliersReducer from '../reducers/suppliersReducer'
import usersReducer from '../reducers/usersReducer'

export default configureStore({
  reducer: {
    auth: authReducer,
    companiesHouse: companiesHouseReducer,
    users: usersReducer,
    clients: clientsReducer,
    bookings: bookingsReducer,
    suppliers: suppliersReducer,
    theme: themeReducer,
  },
  middleware: getDefaultMiddleware({
    serializableCheck: false,
  }),
})
